import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f7d70f1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "SelectedFiltersHeader"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "lnr-redo2 ButtonIcon" }, null, -1 /* HOISTED */))
const _hoisted_3 = {
  class: "FilterTagContainer Collapsed",
  ref: "filterTagContainerRef"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "Badge"
}
const _hoisted_6 = { class: "FilterName" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "lnr-cross ButtonIcon" }, null, -1 /* HOISTED */))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "lnr-plus ButtonIcon" }, null, -1 /* HOISTED */))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "lnr-minus ButtonIcon" }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["SelectedFiltersContainer", { FiltersApplied: _ctx.filtersApplied }])
  }, [
    (_ctx.filtersApplied)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createTextVNode(" Selected filters "),
          (_ctx.removableFiltersCount > 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "ClearButton",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearAll && _ctx.clearAll(...args)))
              }, [
                _createTextVNode(_toDisplayString(_ctx.removableFiltersCount === 1 ? 'Clear filter' : `Clear ${_ctx.removableFiltersCount} filters`) + " ", 1 /* TEXT */),
                _hoisted_2
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["FilterTag", { Disabled: tag.disabled }]),
          onClick: ($event: any) => (tag.clear()),
          key: index
        }, [
          (tag.hasMultipleValues)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(tag.count), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("span", _hoisted_6, _toDisplayString(tag.displayName), 1 /* TEXT */),
          _hoisted_7
        ], 10 /* CLASS, PROPS */, _hoisted_4))
      }), 128 /* KEYED_FRAGMENT */))
    ], 512 /* NEED_PATCH */),
    _createElementVNode("div", null, [
      (_ctx.shouldDisplayShowMore)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "ShowMoreButton",
            ref: "showMoreButtonRef",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showMore && _ctx.showMore(...args)))
          }, [
            _createTextVNode(" Show more "),
            _hoisted_8
          ], 512 /* NEED_PATCH */))
        : _createCommentVNode("v-if", true),
      (_ctx.shouldDisplayShowLess)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            type: "button",
            class: "ShowLessButton",
            ref: "showLessButtonRef",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showLess && _ctx.showLess(...args)))
          }, [
            _createTextVNode(" Show less "),
            _hoisted_9
          ], 512 /* NEED_PATCH */))
        : _createCommentVNode("v-if", true)
    ])
  ], 2 /* CLASS */))
}